module.exports = __webpack_public_path__ + "img/css3.73844123.png";